import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// ========== PARTS ==========
import NavBar from '../parts/NavBar';
import Footer from '../parts/Footer';

// ========== ELEMENTS ==========
import Loader from '../elements/Loader';

// ========== SCSS ==========
import '../scss/power_bi.scss';

// ========== ASSETS ==========
import haoc from '../_assets/images/haoc.png';
import bp from '../_assets/images/bp.png';

export class PowerBi extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: null
    }
  }

  powerBiUrls = {
    haoc: 'https://app.powerbi.com/view?r=eyJrIjoiNTBmYTBmNTctOGQzZS00YzljLThiYWEtYzlmZDhkNGRiYTUyIiwidCI6IjgxZTM4YjRhLWFkOTktNDNmOC04NGFlLWYxZDBkMzkzYzIxNyJ9&pageName=ReportSectionaf4edf35be47b01e202e',
    bp: 'https://app.powerbi.com/view?r=eyJrIjoiZTVkNzc1ZjAtZTg2Yi00MDhlLWI4NGYtOTMwNDk5MGEwNTBmIiwidCI6ImVmNjRkN2QwLWY2ZGQtNDI4Yy1iYzk4LTQ5ZWYxODExZTliNSJ9&pageName=ReportSection'
  }

  // Não está sendo utilizado no momento: solicitação do cliente para trocar fonte
  getContent() {
    if (this.state.selected == null)
      return (
        <div className="content">
          <button className="item" onClick={(e) => {
            this.setState({
              selected: 'haoc'
            })
          }}>
            <img src={haoc}/>
            <h3>HAOC</h3>
          </button>
          <button className="item" onClick={(e) => {
            this.setState({
              selected: 'bp'
            })
          }}>
            <img src={bp}/>
            <h3>BP</h3>
          </button>
        </div>
      );
    else
      return (
        <div className="power_bi-content">
          <div className="back-btn-container">
            <button className="back-btn" onClick={(e) => {
              this.setState({
                selected: null
              })
            }}>
              Voltar
            </button>
          </div>
          <iframe src={this.powerBiUrls[this.state.selected]} allowFullScreen={true} frameBorder={0} />
        </div>
      );
  }

  componentDidMount() {
    window.verifyIfIsLogged();
  }

  render() {
    return (
      <main>
        <NavBar />
        <section id="power_bi">
          <div className="container">
            <h1 className="title">Monitoramento e Informações</h1>
            <div className="power_bi-content">
              <iframe src="https://app.powerbi.com/view?r=eyJrIjoiNzE1MmVlOTMtZGFlYi00ZjE2LWIyZGQtNTIzNGUyOTVkMjE5IiwidCI6IjY3MTk0NmUzLTdlMGItNGUyNy1hMDBhLTJmYmJkZGU0MzQ2MiJ9&pageName=ReportSection" allowFullScreen={true} frameBorder={0} />
            </div>
          </div>
        </section>
        <Footer />
      </main>
    );
  }
}

export default PowerBi
